import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_401: DocMigration = {
  maxSchemaVersion: "0.0.401",
  description: "Add sort index to floor finishes",
  apply(json: any) {
    const { floorFinishes } = json;

    // fix absence of sort index in floor finishes
    // this is not actually used by the app, but is necessary to
    // meet the type contract
    for (const floorFinishId in floorFinishes) {
      const floorFinish = floorFinishes[floorFinishId];

      if (floorFinish.sortIndex === undefined) {
        // add the flags set to the roof
        floorFinishes[floorFinishId] = {
          ...floorFinish,
          sortIndex:
            Object.values(floorFinishes as object)
              .filter((x) => x.parentId === floorFinish.parentId && x.sortIndex !== undefined)
              .reduce((acc, x) => Math.max(acc, x.sortIndex), 0) + 1,
        };
      }
    }

    if (json.snapEntities) {
      json.snapEntities = json.snapEntities.filter((x) => x.entityType !== "PROP");
    }

    const deletedCategories = ["ANNOT_LINEWORK_OFFSETLINE", "ANNOT_LINEWORK_LINE", "ANNOT_LINEWORK_FILL", "PERIMS"];
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      viewTemplate.categories = viewTemplate.categories.filter((x) => !deletedCategories.includes(x));
    }

    return json;
  },
};

export default migration_0_0_401;
